import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useEffect } from "react";

const faqs = [
  {
    question: "Hvordan booker jeg en parkeringsplads?",
    answer:
      "Søg efter en ledig plads, vælg datoer, gennemgå prisen og betal sikkert. Bookingen oprettes, når betalingen er verificeret.",
  },
  {
    question: "Kan jeg afbestille en booking?",
    answer:
      "Ja, afbestilling følger pladsens afbestillingsvilkår. Eventuel refusion afhænger af, hvor tæt på starttidspunktet du afbestiller.",
  },
  {
    question: "Hvornår får jeg den fulde adresse?",
    answer:
      "Fuld adresse og husnummer vises først efter en bekræftet booking. Før booking viser SharePark kun en maskeret adresse.",
  },
  {
    question: "Hvordan bliver mine datoer blokeret?",
    answer:
      "Når betalingen er gennemført og verificeret, oprettes bookingen, så de valgte datoer ikke fremstår som ledige for andre lejere.",
  },
];

export default function FAQ() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title="FAQ om privat parkering | SharePark"
        description="Få svar på spørgsmål om booking, afbestilling, adressevisning og dato-blokering på SharePark."
        keywords="SharePark FAQ, booking parkering, afbestil parkering, privat parkering adresse"
        url="https://sharepark.dk/faq"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: faqs.map((item) => ({
            "@type": "Question",
            name: item.question,
            acceptedAnswer: {
              "@type": "Answer",
              text: item.answer,
            },
          })),
        }}
      />
      <Header />
      <main className="container mx-auto max-w-4xl px-4 py-12">
        <h1 className="mb-4 text-4xl font-bold">Ofte stillede spørgsmål</h1>
        <p className="mb-8 text-muted-foreground">
          Svar på de vigtigste spørgsmål om booking, afbestilling og adressevisning.
        </p>
        <Accordion type="single" collapsible className="w-full rounded-lg border bg-card px-4">
          {faqs.map((item) => (
            <AccordionItem key={item.question} value={item.question}>
              <AccordionTrigger className="text-left font-semibold hover:no-underline">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="leading-7 text-muted-foreground">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </main>
      <Footer />
    </div>
  );
}
